<template>
  <!-- {{ inlay }} -->

  <div
    class="col-6 slider-container"
    :class="{ select: 'move' }"
    id="gt_inlay"
    :style="{
      width: gt.gtDim.width < 1123 ? gt.gtDim.width + 'px' : '420px',
      height: gt.gtDim.height < 1123 ? gt.gtDim.height + 'px' : '420px',
    }"
    @[mayMouseUp]="onmouseUp"
  >
    <draggable-caption
      v-for="(draggable, index) in inlay.draggableTexts"
      :key="'draggable_' + index"
      :text="draggable"
      @changeContent="changeDraggableContent($event, index)"
      @click.stop="switchEditor('description'), selectText(index)"
      @[mayMouseDown]="onDragStart($event, 'draggable_' + draggable.id, index)"
      @[mayMouseUp]="onmouseUp"
      :class="{
        selected: selectedTexts.includes(index),
      }"
    ></draggable-caption>
    <div
      v-if="editor"
      class="inlay"
      :style="{
        'background-color': inlay.style['background-color'],
        'background-image': inlay.style['background-image'],
        'background-size': inlay.style['background-size'],
        'background-position': inlay.style['background-position'],
        height: inlay.style.height,
        top: inlay.style.top,
        left: inlay.style.left,
        width: inlay.style.width,
      }"
      @[mayDrop]="handleFileDrop"
      @[mayDragOver]="onDragOver"
      @[mayDragLeave]="onDragLeave"
    ></div>
    <div
      v-if="dragOver && dragIdx == null"
      :style="{
        height:
          gt.gtDim.height - gt.gtDim.topHeight - gt.gtDim.botHeight - 5 + 'px',
        top: gt.gtDim.topHeight + 'px',
        left: gt.gtDim.lWidth + 'px',
        width: gt.gtDim.width - gt.gtDim.rWidth - gt.gtDim.lWidth - 5 + 'px',
        border: '1px dashed red',
        position: 'absolute',
        'pointer-events': 'none',
      }"
    ></div>
    <div
      v-if="editor == false"
      class="inlay"
      :style="{
        'background-color': inlay.style['background-color'],
        'background-image': inlay.style['background-image'],
        'background-size': inlay.style['background-size'],
        'background-position': inlay.style['background-position'],
        height: inlay.style.height,
        top: inlay.style.top,
        left: inlay.style.left,
        width: inlay.style.width,
      }"
    ></div>

    <div v-if="editor">
      <div
        class="gt-btn"
        :class="{
          selected:
            (dragOver && dragIdx == index) || selectedButtons.includes(index),
        }"
        v-for="(btn, index) in inlay.btns"
        :key="'index_' + index"
        :style="{
          top: btn.style.top,
          left: btn.style.left,
          height: btn.style.height,
          background: btn.style.background,
          width: btn.style.width,
          'border-radius': btn.style['border-radius'],
          cursor: 'pointer',
        }"
        @[mayDrop]="handleFileDrop"
        @[mayDragOver].stop="onDragOverButton($event, index)"
        @[mayDragLeave]="onDragLeaveButton"
        @click="selectButton(index), switchEditor('buttons')"
        @mousedown.stop="buttonDragStart(index)"
        :id="'btn_' + index"
        :draggable="btn.draggable"
      >
        <div
          class="gt-btn-img"
          :style="{
            'background-image': btn.style.image['background-image'],
            'background-position': btn.style.image['background-position'],
            'background-size': btn.style.image['background-size'],
            filter: btn.style.image.filter,
          }"
        ></div>
        <div
          class="d-flex gt-btn-container"
          :class="[
            btn.content.style['justify-content'],
            btn.content.style['align-items'],
          ]"
          :style="{
            border: btn.style['border'],
            background: btn.style.background,
            'background-image': btn.style['background-image'],

            'border-radius': btn.style['border-radius'],
            'background-size': btn.style['background-size'],
          }"
        >
          <p
            v-if="btn.content['d-content']"
            :style="{
              'font-family': btn.content.style['font-family'],
              'font-size': btn.content.style['font-size'],
              color: btn.content.style.color,
              'font-weight': btn.content.style['font-weight'],
              'font-style': btn.content.style['font-style'],
              'text-decoration': btn.content.style['text-decoration'],
              'margin-bottom': gt.name.includes('gsa4')
                ? '12px !important'
                : '',
            }"
            class="btn_text"
            :id="'btn_' + index"
            v-html="btn.content.content"
          ></p>
        </div>
      </div>
    </div>
    <div v-else>
      <div
        class="gt-btn"
        v-for="(btn, index) in inlay.btns"
        :key="'index_' + index"
        :style="{
          height: btn.style.height,
          width: btn.style.width,
          background: btn.style.background,
          top: btn.style.top,
          left: btn.style.left,
          border: btn.style.border,
          'border-radius': btn.style['border-radius'],
          'background-position': 'top',
        }"
      >
        <div
          class="gt-btn-img"
          :style="{
            'background-image': btn.style.image['background-image'],
            'background-position': btn.style.image['background-position'],
            'background-size': btn.style.image['background-size'],
            filter: btn.style.image.filter,
            height: btn.style.height,
            width: btn.style.width,
          }"
        ></div>
        <div
          class="d-flex gt-btn-container"
          :class="[
            btn.content.style['justify-content'],
            btn.content.style['align-items'],
          ]"
          :style="{
            height: btn.style.height,
            width: btn.style.width,
          }"
        >
          <p
            v-if="btn.content['d-content']"
            :style="{
              'font-family': btn.content.style['font-family'],
              'font-size': btn.content.style['font-size'],
              color: btn.content.style.color,
              'font-weight': btn.content.style['font-weight'],
              'font-style': btn.content.style['font-style'],
              'text-decoration': btn.content.style['text-decoration'],
              'margin-bottom': gt.name.includes('gsa4')
                ? '12px !important'
                : '',
            }"
            class="btn_text"
            :id="'btn_' + index"
            v-html="btn.content.content"
          ></p>
        </div>
      </div>
    </div>

    <div v-if="inlay.showLEDs && editor == false">
      <div
        v-for="(led, index) in inlay.leds"
        class="led"
        :key="'led_' + index"
        :style="{
          top: led.style.top,
          left: led.style.left,
          height: led.style.height,
          width: led.style.width,
          'border-radius': inlay.ledRad,
          display: led.style.display,
        }"
      ></div>
    </div>
    <div v-if="inlay.showLEDs && editor">
      <div
        v-for="(led, index) in inlay.leds"
        class="led"
        :class="{
          selected: selectedLEDs.includes(index),
        }"
        style="cursor: pointer"
        :key="'led_' + index"
        :style="{
          top: led.style.top,
          left: led.style.left,
          height: led.style.height,
          width: led.style.width,
          'border-radius': inlay.ledRad,
          display: led.style.display,
        }"
        @click="selectLED(index)"
      ></div>
    </div>
    <div v-if="inlay.showBargraph && inlay.bargraph.length > 0">
      <template v-for="(led, index) in inlay.bargraph">
        <div
          v-if="led.type === inlay.selectedBarGType"
          class="bar_g"
          :class="
            selectedBarGLEDs.findIndex((selLED) => selLED.id == led.id) > -1
              ? 'selected'
              : ''
          "
          :key="'bar_g_' + index"
          :style="{
            top: led.style.top,
            left: led.style.left,
            height: led.style.height,
            width: led.style.width,
            'background-color': led.style['background-color'],
          }"
          @click="selectBarGLED(led)"
        ></div>
      </template>
    </div>
    <div v-if="editor">
      <div v-if="inlay.showBargraphCaptions">
        <template v-for="(bargraphLED, index) in inlay.bargraph">
          <div
            v-if="inlay.selectedBarGType == bargraphLED.type"
            class="bar_g_caption"
            :key="'bar_g_c_' + index"
            :style="{
              top: bargraphLED.caption.style.top,
              left: bargraphLED.caption.style.left,
              color: bargraphLED.caption.style.color,
            }"
          >
            {{ bargraphLED.caption.content }}
          </div>
        </template>
      </div>
    </div>
    <div v-else>
      <div v-if="inlay.showBargraphCaptions">
        <template v-for="(bargraphLED, index) in inlay.bargraph">
          <div
            v-if="inlay.selectedBarGType == bargraphLED.type"
            class="bar_g_caption"
            :key="'bar_g_c_' + index"
            :style="{
              top: bargraphLED.caption.style.top,
              left: bargraphLED.caption.style.left,
              color: bargraphLED.caption.style.color,
            }"
          >
            {{ bargraphLED.caption.content }}
          </div>
        </template>
      </div>
    </div>

    <div
      class="gt-top"
      :style="{
        width: gt.gtDim.width - 4 + 'px',
        height: gt.gtDim.topHeight + 'px',
        'background-image': gt.name.includes('gt10d') ? imgURL() : '',
        'background-repeat': 'no-repeat',
        'background-position': 'center',
        'z-index': gt.name.includes('gt10d') ? 12 : 10,
        'background-color': gt.gtBackground,
      }"
    >
      <div v-if="gt.name.includes('gt10d')">
        <div class="gt10d-button" style="top: 19mm; left: 18mm"></div>
        <div class="gt10d-button" style="top: 19mm; left: 48mm"></div>
        <div class="gt10d-button" style="top: 68mm; left: 18mm"></div>
        <div class="gt10d-button" style="top: 68mm; left: 48mm"></div>
      </div>
    </div>
    <div
      class="gt-right"
      :style="{
        height: gt.gtDim.height - 4 + 'px',
        width: gt.gtDim.rWidth + 'px',
        'background-color': gt.gtBackground,
      }"
    ></div>
    <div
      class="gt-left"
      :style="{
        height: gt.gtDim.height - 4 + 'px',
        width: gt.gtDim.lWidth + 'px',
        'background-color': gt.gtBackground,
      }"
    ></div>
    <div
      class="gt-bottom"
      :style="{
        width: gt.gtDim.width - 4 + 'px',
        height: gt.gtDim.botHeight + 'px',
        'background-color': gt.gtBackground,
      }"
    ></div>
  </div>
</template>

<script>
import {
  computed,
  ref,
  reactive,
  onBeforeMount,
  onBeforeUnmount,
  toRefs,
  nextTick,
} from "vue";
import { useStore } from "vuex";
import fileBase64 from "@/modules/fileBase64";
import DraggableCaption from "./designer/DraggableCaption.vue";
export default {
  props: {
    gt: { type: Object, required: true },
    editor: { type: Boolean, required: true },
    preview: { type: Boolean, default: false },
  },
  components: { DraggableCaption },
  setup(props) {
    const store = useStore();

    const bargraph = computed(() => store.getters.selectedBarG);
    const showBarG = computed(() => store.getters.showBargraph);
    const showLEDs = computed(() => store.getters.showLEDs);
    const selectedBarGLEDs = computed(() => store.getters.selectedBarGLEDs);
    const dragOver = ref(false);
    const dragIdx = ref(null);
    const selectedButtons = computed(() => store.getters.selectedButtons);
    const selectedTexts = computed(() => store.getters.selectedTexts);
    const draggableTexts = computed(() => store.getters.draggableTexts);
    const inlaySave = computed(() => store.getters.inlaySave);
    const showBarGCaptions = computed(() => store.getters.showBargraphCaptions);
    const currentInlayBtns = computed(() => store.getters.currentInlayBtns);
    const mayDrop = computed(() => {
      return store.getters.draggingText != true ? "drop" : null;
    });
    const mayDragOver = computed(() => {
      return store.getters.draggingText != true ? "dragover" : null;
    });
    const mayDragLeave = computed(() => {
      return store.getters.draggingText != true ? "dragleave" : null;
    });
    const buttonDragging = ref(false);
    const oldCoord = reactive({});

    //Funktion zum Hinzufügen der ausgewählten Buttons zur Speicherung im Vuex Store
    function selectButton(idx, deselect = true) {
      if (selectedButtons.value.includes(idx)) {
        if (deselect)
          selectedButtons.value.splice(selectedButtons.value.indexOf(idx), 1);
      } else {
        selectedButtons.value.push(idx);
      }
    }
    function onDragOver(event) {
      event.preventDefault();
      dragOver.value = true;
    }
    function onDragLeave(event) {
      event.preventDefault();
      dragOver.value = false;
    }
    function onDragOverButton(event, index) {
      event.preventDefault();
      dragIdx.value = index;

      dragOver.value = true;
    }
    function onDragLeaveButton(event) {
      event.preventDefault();

      dragIdx.value = null;
      dragOver.value = false;
    }
    function handleFileDrop(event) {
      let droppedFile = event.dataTransfer.files[0];
      event.preventDefault();
      if (!droppedFile) {
        if (buttonDragging.value) {
          currentInlayBtns.value[oldCoord.value.index].style.top =
            currentInlayBtns.value[dragIdx.value].style.top;
          currentInlayBtns.value[oldCoord.value.index].style.left =
            currentInlayBtns.value[dragIdx.value].style.left;
          currentInlayBtns.value[dragIdx.value].style.top = oldCoord.value.top;
          currentInlayBtns.value[dragIdx.value].style.left =
            oldCoord.value.left;
        }
        dragOver.value = false;
        return;
      }
      fileBase64(droppedFile).then((response) => {
        if (dragIdx.value == null)
          store.dispatch("switchInlayBackgroundImg", "url(" + response + ")");
        else
          store.dispatch("changeButtonStyle", {
            index: dragIdx.value,
            style: "background-image",
            value: "url(" + response + ")",
          });
      });
      dragOver.value = false;
    }
    function selectBarGLED(led) {
      if (
        selectedBarGLEDs.value.findIndex((selLED) => selLED.id == led.id) > -1
      )
        selectedBarGLEDs.value.splice(
          selectedBarGLEDs.value.findIndex((selLED) => selLED.id == led.id),
          1
        );
      else selectedBarGLEDs.value.push(led);
    }
    function buttonDrag(event) {
      //console.log(event);
    }
    function buttonDragStart(index) {
      buttonDragging.value = true;
      oldCoord.value = {
        top: currentInlayBtns.value[index].style.top,
        left: currentInlayBtns.value[index].style.left,
        index: index,
      };
    }
    function switchEditor(editor) {
      store.dispatch("switchEditor", editor);
    }
    function imgURL() {
      return "url(" + process.env.BASE_URL + "images/gt/GT10Dw_top.png)";
    }
    const draggingDraggable = ref(false);
    function draggableStart(e) {
      draggingDraggable.value = true;
      // console.log("starting", e);
    }
    function draggableStop(e) {
      //console.log("stopping", e);
    }
    function draggableMove(e) {
      //if (draggingDraggable.value) console.log("moving", e);
    }
    function changeDraggablePos(e, idx) {
      store.commit("setDraggableTextCoord", {
        index: idx,
        top: e.top,
        left: e.left,
      });
    }
    function changeDraggableContent(e, index) {
      store.commit("setDraggableTextContent", { index: index, text: e });
    }
    const mayMouseDown = computed(() => {
      let mousedown = "null";
      if (draggableTexts.value.length > 0)
        mousedown = draggableTexts.value[0].editable ? "null" : "mousedown";
      return mousedown;
    });
    const mayMouseUp = computed(() => {
      let mouseup = "null";
      if (draggableTexts.value.length > 0)
        mouseup = draggableTexts.value[0].editable ? "null" : "mouseup";
      return mouseup;
    });
    const currentGT6L = computed(() => store.getters.currentGT6LInlay);

    const inlay = computed(() => {
      if (props.gt.name.includes("gt6l")) {
        return props.gt.inlay[currentGT6L.value];
      } else {
        return props.gt.inlay;
      }
    });
    const sanitizedBackgroundImage = computed(() => {
      return props.gt.inlay.style["background-image"].replace(
        /^["']|["']$/g,
        ""
      );
    });
    const textPos = reactive({
      index: null,
      newX: 0,
      newY: 0,
      prevX: 0,
      prevY: 0,
      offsetTop: 0,
      offsetLeft: 0,
    });
    const dragging = ref(false);
    const inlayPos = reactive({
      top: props.gt.name.includes("gt10")
        ? 18.897
        : parseFloat(
            inlay.value.style.top.substring(0, inlay.value.style.top.length - 2)
          ) * 3.7795275591,
      left:
        parseFloat(
          inlay.value.style.left.substring(0, inlay.value.style.left.length - 2)
        ) * 3.7795275591,
      right:
        parseFloat(
          inlay.value.style.left.substring(0, inlay.value.style.left.length - 2)
        ) *
          3.7795275591 +
        parseFloat(
          inlay.value.style.width.substring(
            0,
            inlay.value.style.width.length - 2
          )
        ) *
          3.7795275591,
      bottom: props.gt.name.includes("gt10")
        ? 570
        : parseFloat(
            inlay.value.style.top.substring(0, inlay.value.style.top.length - 2)
          ) *
            3.7795275591 +
          parseFloat(
            inlay.value.style.height.substring(
              0,
              inlay.value.style.height.length - 2
            )
          ) *
            3.7795275591,
    });
    function onDragStart(event, id, index) {
      let el = document.getElementById(id);
      event.preventDefault();
      textPos.offsetTop = el.parentNode.getBoundingClientRect().top;
      textPos.offsetLeft = el.parentNode.getBoundingClientRect().left;
      dragging.value = true;
      store.dispatch("dragText", true);
      textPos.prevX = event.pageX - textPos.offsetLeft - 20;
      textPos.prevY = event.pageY - textPos.offsetTop - 20;
      textPos.index = index;
      // console.log(event, "event");
    }
    function onmouseMove(event) {
      if (dragging.value) {
        event.preventDefault();

        textPos.newX = textPos.prevX;
        textPos.newY = textPos.prevY;
        // textPos.newY > inlayPos.top &&
        if (
          textPos.newX > inlayPos.left &&
          textPos.newX < inlayPos.right &&
          textPos.newY < inlayPos.bottom
        )
          store.commit("setDraggableTextCoord", {
            index: textPos.index,
            top: textPos.newY + "px",
            left: textPos.newX + "px",
          });
        textPos.prevX = event.pageX - textPos.offsetLeft - 20;
        textPos.prevY = event.pageY - textPos.offsetTop - window.scrollY - 20;
      }
    }

    function onmouseUp() {
      dragging.value = false;
      store.dispatch("dragText", false);
    }

    const moveTexts = computed(() => store.getters.moveTexts);
    function selectText(index) {
      if (!moveTexts.value) {
        if (selectedTexts.value.indexOf(index) > -1)
          selectedTexts.value.splice(selectedTexts.value.indexOf(index), 1);
        else selectedTexts.value.push(index);
      }
    }
    function changeBargraphCaption(event, index) {
      let replacement = new RegExp(String.fromCharCode(160), "g");

      event.target.innerHTML = event.target.innerHTML.replace(replacement, " ");
      //console.log(event.target.innerHTML);
      store.commit("setBargraphCaptionContent", {
        id: index,
        content: event.target.innerHTML,
      });
    }
    onBeforeMount(() => {
      document.addEventListener("mousemove", onmouseMove, false);
    });
    onBeforeUnmount(() => {
      document.removeEventListener("mousemove", onmouseMove, true);
    });

    const currentEditor = computed(() => store.getters.currentEditor);
    const selectedLEDs = computed(() => store.getters.selectedLEDs);
    function selectLED(index) {
      if (selectedLEDs.value.findIndex((selLED) => selLED == index) < 0)
        selectedLEDs.value.push(index);
      else
        selectedLEDs.value.splice(
          selectedLEDs.value.findIndex((selLED) => selLED == index),
          1
        );
    }

    return {
      selectButton,
      bargraph,
      showBarG,
      showLEDs,
      onDragOver,
      onDragLeave,
      onDragOverButton,
      onDragLeaveButton,
      onDragStart,
      onmouseMove,
      onmouseUp,
      handleFileDrop,
      dragOver,
      dragIdx,
      selectedBarGLEDs,
      selectBarGLED,
      selectedButtons,
      inlaySave,
      showBarGCaptions,
      mayDrop,
      mayDragOver,
      mayDragLeave,
      mayMouseDown,
      mayMouseUp,
      buttonDrag,
      buttonDragStart,
      switchEditor,
      imgURL,
      draggableStart,
      draggableStop,
      draggableMove,
      changeDraggablePos,
      changeDraggableContent,
      selectedTexts,
      selectText,
      changeBargraphCaption,
      currentEditor,
      selectLED,
      selectedLEDs,
      inlay,
      sanitizedBackgroundImage,
    };
  },
};
</script>

<style lang="scss" scoped>
.slider-container {
  // display: block;
  border: 2px solid grey;
  border-radius: 5px;
  position: relative;
  margin-top: 30px;
  overflow: hidden;
  p {
    margin-bottom: 1px !important;
    z-index: 100;
    white-space: pre-wrap;
  }
}
.gt-btn {
  border: 1px dashed grey;
  position: absolute;
  display: grid;
}
.gt-btn-img {
  background-repeat: no-repeat;
  z-index: 5;
  height: 100%;
  width: 100%;
  grid-row-start: 1;
  grid-column-start: 1;
  pointer-events: none;
}

.inlay {
  position: absolute;
  background-repeat: no-repeat;
  min-height: 100px;
  min-width: 100px;
}
.gt-top,
.gt-bottom {
  position: absolute;
  left: 0;
  z-index: 10;
  background-color: #fff;
}
.gt-top {
  top: 0;
}
.gt-bottom {
  bottom: 0;
}
.gt-right,
.gt-left {
  position: absolute;
  z-index: 10;
  background-color: #fff;
}
.gt-right {
  right: 0;
}
.gt-left {
  left: 0;
}

.inlay-name {
  margin-top: 50px;
}
.gt-btn-container {
  height: 100%;
  width: 100%;
  grid-row-start: 1;
  grid-column-start: 1;
  pointer-events: auto;
}
.led {
  position: absolute;
  background-color: white;
  border: 1px dashed gray;
}
.bar_g {
  position: absolute;
  cursor: pointer;
}
.selected {
  border: 2px dashed red;
}
.bar_g_caption {
  position: absolute;
  font-size: 10px;
  line-height: 2.18mm;
  font-weight: bold;
  cursor: pointer;
}
.move {
  cursor: move;
}
.gt10d-button {
  width: 22mm;
  border: 1px solid grey;
  position: absolute;
}
.btn_text {
  word-break: break-word;
}
.inlay::before {
  // background-image: var(--bg);
  background-color: red;
  min-height: 100px;
  min-width: 100px;
  z-index: 100;
  position: absolute;
}
</style>
